module.exports = __webpack_public_path__ + "img/title_lfm1.6baee978.png";